export const getPaginationArray = (keys, currentPage, maximumPage) => {
  let arr = [];

  if (keys.length < 5) {
    arr = keys.slice(1, keys.length);
    arr.push(keys.length);
  } else if (currentPage >= 4 && currentPage + 4 < keys.length) {
    arr = keys.slice(currentPage - 1, currentPage + 2);
  } else if (currentPage < 4) {
    arr = [1, 2, 3, 4, 5];
  } else if (currentPage + 4 === keys.length) {
    arr = keys.slice(keys.length - 5, keys.length - 2);
  } else if (currentPage + 4 > keys.length) {
    arr = keys.slice(keys.length - 4, keys.length);
    arr.push(maximumPage);
  }

  return arr;
};
